<template>
  <div v-editable="blok" :class="'thumbnail thumbnail--' + blok.variation">
    <a v-if="blok.link" :href="blok.link">
      <div v-if="getImageUrl(blok)" class="thumbnail__image">
        <picture>
          <component
            :is="'a_imageSource' | dashify"
            :blok="blok"
            :image-url="getImageUrl(blok)"
            :alt="blok.title"
          />
        </picture>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Thumbnail',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getImageUrl: (config) => {
      /* eslint-disable no-else-return */
      if (config.image) {
        return config.image
      } else if (
        config.thumbnail_source &&
        config.thumbnail_source[0] &&
        config.thumbnail_source[0].image
      ) {
        return config.thumbnail_source[0].image
      }
      return ''
    },
    formatDate(date) {
      const dateArray = date.substring(0, 10).split('-')
      const monthId = Number(dateArray[1]) - 1

      return `${dateArray[2]} / ${this.$options.filters.monthName(monthId)} / ${
        dateArray[0]
      }`
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.has-touch {
  .thumbnail__read-more {
    opacity: 1;
    transform: translateY(0);
  }
}

.thumbnail {
  .icon--arrow {
    &::before {
      @include font-size(10);

      margin-right: 10px;
    }
  }
  &--news {
    .thumbnail__title {
      @include font-size(16, rem-v(28));

      flex: 1 1 auto;
      margin-bottom: 0;
    }
  }

  &--our-work {
    .thumbnail__image {
      margin-bottom: ($spacer * 2);
    }

    .thumbnail__title {
      @include font-size(38, rem-v(54));

      margin-bottom: 10px;
    }

    .thumbnail__description {
      margin: 0 0 ($spacer * 0.5);
    }
  }
}

.thumbnail:hover {
  border: 2px solid red;
}

.thumbnail__image {
  margin-bottom: 27px;
  overflow: hidden;

  picture {
    width: 100%;
    display: inline-block;
    transform: scale(1);
    transition: transform 0.3s ease-out 0.3s;
  }

  img {
    width: 100%;
    transition: all 0.3s ease-out;
  }
}

.thumbnail__company {
  margin-top: 0;
  transition: color 0.3s ease;
}

.thumbnail__read-more {
  display: inline-block;
  margin: 20px 0 0;
  opacity: 0;
  transition: all 0.2s ease-in 0.1s;
  transform: translateY(-10px);
}

.thumbnail__topic {
  @include font-size(14, rem-v(24));

  margin: 0 0 ($spacer);
  color: $tribal-black;
  transition: color 0.3s ease;
}

p.thumbnail__date {
  @include font-size(14, rem-v(16));

  color: $oslo-gray;
  margin-bottom: 26px;
  margin-top: 0;
}

.thumbnail__title {
  @include font-family($font-family-headings-bold, $headings-font-weight);

  margin: 0 0 $spacer;
  color: $tribal-black;
  flex: 0 1 auto;
  transition: color 0.3s ease;
}

.thumbnail__description {
  margin: 0 0 $spacer;
  transition: color 0.3s ease;
}

.thumbnail__tags {
  @include font-size(14, rem-v(24));

  display: block;
  color: $oslo-gray;
}

@include media-breakpoint-up(md) {
  .thumbnail {
    &--our-work {
      .thumbnail__image {
        img {
          max-height: 428px;
        }
      }
    }
  }

  .thumbnail__title {
    min-height: 56px;
  }
}
</style>
